import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { queryTypes, servicesUserTypes } from 'src/types';
import { urlsConfig } from 'src/configs';
import { urlHelper } from '../helpers';

export const lookupUsersOfEvent = ({
  limit,
  offset,
  ids,
  value,
  order,
  eventIdsArray,
  sortOrder,
  blockSpinner,
  load,
}: servicesUserTypes.UsersLookupDataType): AxiosPromise<servicesUserTypes.UserOfEventAndOntologyLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (eventIdsArray && eventIdsArray.length > 0) {
    query.eventIds = eventIdsArray.join(',');
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.userofevent.lookupUserOfEvent), {
    blockSpinner,
  });
};
